const MESSAGES = {
  requiredField: 'Campo obrigatório.',
  validCep: 'Digite um cep válido.',
  onlyNumbers: 'Apenas números.',
  onlyLetters: 'Insira apenas letras.',
  invalidField: 'Campo inválido',
  minCharacters: min => `Mínimo ${min} caracteres`,
  date: {
    required: 'Data é obrigatória.',
    requiredBirthday: 'Data de nascimento é obrigatória.',
    invalid: 'Por favor digite uma data válida.',
    invalidFuture: 'Data de nascimento inválida.',
    dateMethuselah:
      'Desculpe, mas pessoas com mais de 100 anos não podem se cadastrar.',
    dateVeryYoung: 'Você deve ter mais de 16 anos para se cadastrar.',
  },
  phone: {
    required:
      'Insira o DDD e um número de celular válido. Caso seja de fora do Brasil, adicione o símbolo +, o DDI e o número.',
    invalid:
      'Insira o DDD e um número de celular válido. Caso seja de fora do Brasil, adicione o símbolo +, o DDI e o número.',
  },
  email: {
    required: 'É obrigatório informar seu e-mail.',
    invalid: 'Digite um e-mail válido.',
    maxCharacters:
      'e-mail inválido por ter ultrapassado o limite de caracteres.',
  },
  password: {
    required: 'É obrigatório informar sua senha.',
    invalid:
      'Sua senha deverá ter no mínimo 8 dígitos, formada por letras e números.',
    notSame: 'As senhas digitadas não estão iguais',
  },
  cpf: {
    invalid: 'O CPF está inválido, por favor verifique os números digitados',
  },
};

export default MESSAGES;
